import React from "react";
import PropTypes from "prop-types";

import { GetPriceRealAndPoints, FormatPoints } from "../../lib/FormatCurrency";
import { Container, Tachado, Box } from "./styles";

export default function PriceDetailProduct({
  price,
  orientation,
  justifyContent,
  displayMode = "both",
}) {
  const { money_de, points_de, money, points } = GetPriceRealAndPoints(price);

  const moneyDeValue = price?.BRL?.price || 0;
  const moneyOfferValue = price?.BRL?.offer || 0;
  const showMoneyDe = money_de && moneyDeValue > moneyOfferValue;
  const showPointsDe = points_de > 0 && points_de > points;

  return (
    <Container orientation={orientation} justifyContent={justifyContent} className="mt-4 mb-4">
      {(displayMode === "money" || displayMode === "both") && (
        <Box>
          {showMoneyDe && (
            <Tachado className="tachado-price">{money_de}</Tachado>
          )}
          <span>
            <p className="por-price">{money}</p>
          </span>
        </Box>
      )}

      {points > 0 && (displayMode === "points" || displayMode === "both") && (
        <Box>
          {showPointsDe && (
            <Tachado className="tachado-price">
              {FormatPoints(points_de)} pts
            </Tachado>
          )}
          <span>
            <p className="por-price">{FormatPoints(points)} pts</p>
          </span>
        </Box>
      )}
    </Container>
  );
}

PriceDetailProduct.propTypes = {
  price: PropTypes.object.isRequired,
  orientation: PropTypes.string,
  justifyContent: PropTypes.string,
  displayMode: PropTypes.oneOf(["money", "points", "both"]),
};
